import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundCloseOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.boundCloseAll = this.close.bind(this)
    this.openTimer = null
    window.addEventListener("dropdown:closeAll", this.boundCloseAll)
  }

  disconnect() {
    window.removeEventListener("dropdown:closeAll", this.boundCloseAll)
    if (this.openTimer) {
      clearTimeout(this.openTimer)
      this.openTimer = null
    }
    document.removeEventListener("click", this.boundCloseOnOutsideClick)
    this.menuTarget.classList.remove("open")
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.menuTarget.classList.contains("open")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    window.dispatchEvent(new CustomEvent("dropdown:closeAll", { bubbles: true }))

    this.menuTarget.classList.add("open")
    this.element.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "true")

    this.openTimer = setTimeout(() => {
      this.openTimer = null
      document.addEventListener("click", this.boundCloseOnOutsideClick)
    }, 0)
  }

  close() {
    if (this.openTimer) {
      clearTimeout(this.openTimer)
      this.openTimer = null
    }
    this.menuTarget.classList.remove("open")
    this.element.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.boundCloseOnOutsideClick)
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
